import { Controller, useFormContext } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Select, FormControl, FormHelperText } from '@mui/material';
import { FormError } from './hook-form-error';
import React from 'react';

export interface SelectFieldOption {
  value: any;
  label: string;
  type?: string; // 👈 right-side text (Income / Expenses / etc.)
  isDefault?: boolean;
}

interface SelectFieldProps {
  options: SelectFieldOption[];
  label: string;
  name: string;
  selectInfo?: any;
  onChange?: any;
  disabled?: boolean;
  className?: string;
  required?: boolean;
}

export const FormSelect = ({
  name,
  label,
  options,
  selectInfo,
  onChange,
  disabled,
  className,
  required,
}: SelectFieldProps): any => {
  const { control } = useFormContext();

  const handleChange = (value: any) => {
    onChange(value);
  };

  return (
    <div>
      <div className="select">
        <Controller
          control={control}
          name={name}
          render={({ field }) => {
            const selectedOption = options.find((o) => o.value === field.value);

            return (
              <FormControl fullWidth disabled={disabled}>
                <InputLabel size="small" id={`${name}-select-label`}>
                  {label}
                </InputLabel>

                <Select
                  size="small"
                  labelId={`${name}-select-label`}
                  id={`${name}-select`}
                  label={label}
                  value={field.value || ''}
                  onChange={(e) => {
                    field.onChange(e);
                    handleChange(e.target.value);
                  }}
                  // displayEmpty
                  renderValue={(selected) => {
                    if (!selected) return '';
                    const option = options.find((o) => o.value === selected);
                    if (!option) return '';
                    return (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <span>{option.label}</span>
                        {option.type && (
                          <span
                            style={{
                              color: '#6b6b6b',
                              fontSize: '0.85rem',
                              fontStyle: 'italic',
                            }}
                          >
                            {option.type}
                          </span>
                        )}
                      </div>
                    );
                  }}
                  className={`${className} ${required ? 'itsarequiredField' : ''} ${
                    field.value ? 'has-data' : ''
                  }`}
                >
                  {options?.map((o) => (
                    <MenuItem
                      key={`${name}-${o.value}`}
                      value={o.value}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <span>{o.label}</span>
                      {o.type && (
                        <span
                          style={{
                            color: '#6b6b6b',
                            fontSize: '0.85rem',
                            fontStyle: 'italic',
                          }}
                        >
                          {o.type}
                        </span>
                      )}
                    </MenuItem>
                  ))}
                </Select>

                <FormHelperText>{selectInfo}</FormHelperText>
              </FormControl>
            );
          }}
        />
        <FormError name={name} />
      </div>
    </div>
  );
};

FormSelect.defaultProps = {
  onChange: () => {
    return;
  },
};
